// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"188":"e51d94e5","594":"e031b1c0","864":"9dddc9bc","869":"e45297c8"}[chunkId] + ".css";
};